.mappedin-map {
	.mappedin-interactive {
		cursor: grab;

		&:active {
			cursor: grabbing;
		}

		&.mappedin-interaction-hover {
			cursor: pointer;
		}
	}
}
